
import { useEffect, useState } from "react";
import { RequestsServicesProps } from "../../../@types/requests";
import { getAtendentes, getRequestAll } from "../../../services/requests";
import InpuSearch from "../components/InputSearch";
import Filters from "../components/Filters";
import { CustomButton, FilterContainer } from "./style";
import { FaFilter } from "react-icons/fa";
import { MdCleaningServices } from "react-icons/md";
import TableReports from "../components/TableReports";
import Paginate from "../../../Components/Paginate";
import { getSectorDataNoPaginate } from "../../../services/organ";
import { CardFooterCustom } from "../style";
import { TbListSearch } from "react-icons/tb";

const initialFilters = {
  status: [],
  model: {
    label: '',
    value: ''
  },
  createdData: '',
  dataFim: '',
  service: '',
  orgao: {
    label: '',
    value: ''
  },
  title: '',
  organSelected: 0,
  organSlugSelected: '',
  flow__slug: '',
  setor: [],
  cpf: '',
  protocol: '',
  data: '',
  flowSlug: '',
  servicoSlug: {
    label: '',
    value: ''
  },
  atendente: [],
  dataInicio: '',
};

interface FlowtabRequests {
  filtersRequests: any,
  setFiltersRequests: any
}

interface ServicoSlug {
  label: string;
  value: string;
}


const Requests = ({ setFiltersRequests }: FlowtabRequests) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<RequestsServicesProps | undefined>();
  const [servicoSlug, setServicoSlug] = useState<ServicoSlug>({ label: '', value: '' });
  const [dataSectors, setDataSectors] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState(initialFilters);
  const [dataAtendentes, setDataAtendentes] = useState([]);
  const [fetchTrigger, setFetchTrigger] = useState(0);

  const fetchData = async ({ page }: { page: number }) => {
    setLoading(true);
    try {
      let response;
      const params = {
        page,
        search: search,
        orgao: filters.orgao.value,
        modelo: filters.model.value,
        servico: '',
        data: filters.createdData,
        setor: filters.setor,
        titulo: filters.title,
        data_inicio: filters.dataInicio,
        data_fim: filters.dataFim,
        protocolo: filters.protocol,
        servico_slug: servicoSlug.value,
        cpf: filters.cpf.replace(/[.-]/g, ''),
      };
      response = servicoSlug.value && await getRequestAll(filters.status, params);
      setData(response.data);
      const responseSector = await getSectorDataNoPaginate(filters.organSelected);
      const responseAtendentes = await getAtendentes();
      setDataSectors(responseSector.data);
      setDataAtendentes(responseAtendentes.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchData({ page: 1 });
    setFilters({ ...filters, servicoSlug: { label: servicoSlug.label, value: servicoSlug.value }, flow__slug: data?.results[0]?.flow?.slug })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [servicoSlug]);

  const onChangeFilters = () => {
    setShowFilters(!showFilters)
  }

  const clearFilters = () => {
    setFilters(currentFilters => ({
      ...initialFilters,
      organSelected: currentFilters.organSelected,
    }));
    setFetchTrigger(prevTrigger => prevTrigger + 1);
  };

  useEffect(() => {
    fetchData({ page: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchTrigger]);

  useEffect(() => {
    setFiltersRequests({ ...filters, servicoSlug: { label: servicoSlug.label, value: servicoSlug.value }, flowTitle: data?.results[0]?.flow?.titulo, flow__slug: data?.results[0]?.flow?.slug })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, data?.results[0]?.flow?.titulo, data?.results[0]?.flow?.slug]);

  return (
    <>
      <InpuSearch
        setSearchData={setSearch}
        searchData={search}
        isSearch={search !== ""}
        onShowFilters={() => onChangeFilters()}
        filters={filters}
        setFilters={setFilters}
        setSearch={setSearch}
        fetchData={fetchData}
        setServicoSlug={setServicoSlug}
        isRequestsTab={true}
      />

      {showFilters && <Filters sectors={dataSectors} dataAtendentes={dataAtendentes} setFilters={setFilters} filters={filters} />}

      {showFilters &&
        <FilterContainer>
          <CustomButton variant="filter" onClick={() => fetchData({ page: 1 })}>
            <FaFilter size={20} /> Filtrar
          </CustomButton>
          <CustomButton variant="clear" onClick={() => clearFilters()} >
            <MdCleaningServices size={20} /> Limpar
          </CustomButton>
        </FilterContainer>
      }

      {servicoSlug.label && (
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center">
            <TbListSearch size="20" className="text-primary mr-2" />
            <strong style={{ marginRight: '5px', marginLeft: '3px' }}>{data?.count}</strong>
            <span>Solicitações encontradas</span>
          </div>
          <div>
            <span className="text-secondary">Resultado da busca por:</span>
            <strong style={{ marginLeft: '5px' }}>{servicoSlug.label}</strong>
          </div>
        </div>
      )}
      <TableReports loading={loading} results={data?.results} />
      <CardFooterCustom>
        {data?.total_pages > 0 && (
          <Paginate
            flowData={data}
            setPage={fetchData}
            page={data?.current}
          />
        )}
      </CardFooterCustom>

    </>
  )
}

export default Requests